import { Component } from '@angular/core';

@Component({
	selector: 'app-resources-manager-showcase',
	templateUrl: './resources-manager-showcase.component.html',
	styleUrls: ['./resources-manager-showcase.component.scss'],
	standalone: false,
})
export class ResourcesManagerShowcaseComponent {
	constructor() {}
}
